import _objectSpread from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
var moment = require("moment");
import { ActivityTransformer } from "@/transformers/ActivityTransformer";
import { LastActionTransformer } from "@/transformers/LastActionTransformer";
export default {
  data: function data() {
    return {
      noMore: false,
      extraClass: {},
      activities: [],
      notifications: [],
      count: 0
    };
  },
  computed: {
    config: {
      get: function get() {
        return this.$store.state.notification.config;
      },
      set: function set(val) {
        this.$store.state.notification.config = val;
      }
    },
    scheduledDoNotDisturb: {
      get: function get() {
        return this.$store.state.notification.scheduledDoNotDisturb;
      },
      set: function set(val) {
        this.$store.state.notification.scheduledDoNotDisturb = val;
      }
    }
  },
  methods: {
    getNotificationText: function getNotificationText() {
      if (this.scheduledDoNotDisturb) {
        return this.$t('In order to activate notifications please remove restrictions');
      } else {
        return this.$t('Notification is') + ' : ' + (this.mutableConfig.paused == 0 ? 'off' : 'on');
      }
    },
    handleView: function handleView(att) {
      var record_id = att.record_id;
      var model = att.model;
      var app = att.app;
      var r = "".concat(this.$kvAttachmentViewPath, "?app=") + app + "&model=" + model + "&record_id=" + record_id + "&file_name=" + att.name + "&file_type=" + att.file_type + "&uid=" + att.file_id + "&_blank=1&_csrf=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOjI5MzI0LCJleHAiOjE1ODQ1MDA4Mjl9.Hb-ptWmjnoDhg7sGkXa2PDjJQ-K0UpoU6fjVEi7MAh4";
      var viewer = this.$el.querySelector(".viewer-".concat(att.file_id)).$viewer;
      viewer.show();
    },
    getTask: function getTask(params) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var id, modulex;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              id = params.r;
              modulex = params.m;
              if (modulex == "task") {
                _this.tasksPopup.task = {
                  record_id: id,
                  setActivityDrawer: true
                };
                _this.tasksPopup.show = true;
                _this.activityDrawer = false;
              } else if (modulex == "thread") {
                _this.$router.push({
                  path: "/inbox/" + id,
                  query: {
                    open: "comments"
                  }
                });
              }
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getNotifications: function getNotifications() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var limit, offset, addition;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(_this2.noMore == false)) {
                _context2.next = 9;
                break;
              }
              _this2.loading = true;
              limit = _this2.limit;
              offset = _this2.count * limit;
              addition = {};
              if (_this2.project && _this2.project.project_id) {
                addition.project = _this2.project.project_id;
              }
              _context2.next = 8;
              return new KivaProxy({
                endpoint: "kvc/data/notification",
                driver: "base"
              }).setParameters(addition).setStart(offset).setLimit(limit).all().then(function (response) {
                var _this2$notifications;
                _this2.loading = false;
                if (!response.data[0]) {
                  _this2.noMore = true;
                }
                var list = ActivityTransformer.fetchCollection(response.data, _this2.$locale);
                (_this2$notifications = _this2.notifications).push.apply(_this2$notifications, _toConsumableArray(list));
              });
            case 8:
              _this2.count += 1;
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getActivities: function getActivities() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var limit, offset, addition;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(_this3.noMore == false)) {
                _context3.next = 8;
                break;
              }
              _this3.loading = true;
              limit = _this3.limit ? _this3.limit : 8;
              offset = _this3.count * limit;
              addition = {};
              if (_this3.project) {
                addition.project = _this3.project;
              }
              _context3.next = 8;
              return new KivaProxy({
                endpoint: "kvc/data/history/me",
                driver: "base"
              }).setParameters(_objectSpread({
                'actionId': "1,2,10",
                calcFoundRows: 1
              }, addition)).setStart(offset).setLimit(limit).all().then(function (response) {
                var _this3$activities;
                _this3.loading = false;
                if (!response.records) {
                  _this3.noMore = true;
                }
                var list = LastActionTransformer.fetchCollection(response.records, _this3.$locale);
                (_this3$activities = _this3.activities).push.apply(_this3$activities, _toConsumableArray(list));
                _this3.count += 1;
              });
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    checkDoNotDisturbStatus: function checkDoNotDisturbStatus() {
      var config = this.config;
      var today = moment();
      var dayOfWeek = today.format('e') - 1;
      var pDays = config.pausedAtDays;
      if (pDays.includes(dayOfWeek)) {
        var format = 'HH:mm';
        var time = moment(),
          beforeTime = moment(config.pausedBetweenTime[0], format),
          afterTime = moment(config.pausedBetweenTime[1], format);
        if (time.isBetween(beforeTime, afterTime)) {
          this.scheduledDoNotDisturb = true;
        } else {
          this.scheduledDoNotDisturb = false;
        }
      } else {
        this.scheduledDoNotDisturb = false;
      }
      // pausedBetweenTime
      // pausedAtDays
    }
  }
};